// extracted by mini-css-extract-plugin
export var divider = "_lw-0";
export var labelWrapper = "_lw-2";
export var lineSvg = "_lw-1";